import { useEffect, useState } from "react";
import { HTTP_METHODS, invokeApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import CustomTable from "../../../../core/custom-table";
import "./index.scss";
import { Check, RemoveRedEyeOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import { TabContext, TabPanel } from "@mui/lab";

const TrainingApprovalStatus = () => {
  const navigate = useNavigate();
  const [trainingDetailsList, setTrainingDetailsList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [trainingRequestList, setTrainingRequestList] = useState([]);
  const [totalTrainingDetails, setTotalTrainingDetail] = useState({});
  const [totalTrainingRequestDetails, setTotalTrainingRequestDetail] = useState(
    {}
  );

  const [filters, setFilters] = useState({
    page: 2,
  });

  const trainingDetailsConfig = {
    HeaderConfig: [
      {
        label: "S l No.",
        id: "serialNumber",
      },
      {
        label: "Course Desired",
        id: "courseName",
      },
      {
        label: "Course Start Date",
        id: "courseStartDate",
      },
      {
        label: "Course End Date",
        id: "courseEndDate",
      },
      {
        label: "No. of the Candidates",
        id: "numberOfParticipants",
      },

      {
        label: "Venue",
        id: "venue",
      },
      {
        label: "Dealer Name",
        id: "dealerName",
      },
      {
        label: "View Details",
        id: "viewDetails",
        render: (data) => {
          return (
            <span className="view-list-icon">
              <RemoveRedEyeOutlined onClick={() => viewParticipantList(data)} />
            </span>
          );
        },
      },
      {
        label: "Approval Status",
        id: "approvalStatus",
        render: (data) => {
          return (
            <span className={`approval-${data.approvalStatus.toLowerCase()}`}>
              {data.approvalStatus}
            </span>
          );
        },
      },
      {
        label: "Completed",
        id: "status",
        render: (data) => {
          return (
            data.status === "COMPLETED" && (
              <Check
                fontSize="small"
                style={{
                  color: "#ffffff",
                  backgroundColor: "#118d57",
                  borderRadius: "20px",
                  padding: "5px",
                  fontWeight: "600",
                }}
              />
            )
          );
        },
      },
    ],
  };

  useEffect(() => {
    getTrainingDetailsList(filters);
    getRequestedTrainingList(filters);
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const viewParticipantList = (data) => {
    navigate("/oem/training/training-request-details", {
      state: { candidatesDetails: [{ ...data }] },
    });
  };

  const loadData = () => {
    getRequestedTrainingList(filters);
    getTrainingDetailsList(filters);
  };

  const getTrainingDetailsList = (filters) => {
    setTrainingDetailsList([]);
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.OEM_APPROVAL_STATUS}`,
      null,
      filters
    ).then((response) => {
      setTotalTrainingDetail({ ...response });
      setTrainingDetailsList(
        response?.map((data, index) => ({
          serialNumber: index + 1,
          courseStartDate:
            data?.course?.courseDuration?.startDate?.split("T")[0],
          courseEndDate: data?.course?.courseDuration?.endDate?.split("T")[0],
          approvalStatus: data.approvalStatus,
          rejectionComment: data?.rejectionComment || "",
          ...data,
        }))
      );
    });
  };

  const getRequestedTrainingList = (filters) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.OEM_APPROVAL_STATUS}?status=PENDING`,
      null
    ).then((response) => {
      setTotalTrainingRequestDetail({ ...response });
      setTrainingRequestList(
        response?.map((listItem, index) => ({
          serialNumber: index + 1,
          courseStartDate:
            listItem?.courseDuration?.startDate?.split("T")[0] ||
            listItem?.course?.courseDuration?.startDate?.split("T")[0],
          courseEndDate:
            listItem?.courseDuration?.endDate?.split("T")[0] ||
            listItem?.course?.courseDuration?.endDate?.split("T")[0],
          model: listItem?.model,
          id: listItem?.id,
          status: listItem?.status,
          requestedBy: listItem?.requestedBy,
          approvalStatus: listItem?.approvalStatus,
          rejectionComment: listItem?.rejectionComment || "",
          ...listItem,
        }))
      );
    });
  };

  return (
    <>
      <div className="training-approval-list-container">
        <div className="title-container">
          <span className="training-title">Training</span>
          <div className="list-title">Training Approval Status</div>
        </div>
        <div className="list-container">
          <Box sx={{ width: "100%" }}>
            <TabContext value={String(activeTab)}>
              <Box>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  scrollButtons
                  variant="scrollable"
                  allowScrollButtonsMobile
                >
                  <Tab
                    label={`Training Request (${trainingDetailsList.length})`}
                    value={0}
                  />
                  <Tab
                    label={`Special Request (${trainingRequestList.length})`}
                    value={1}
                  />
                </Tabs>
              </Box>

              <TabPanel value="0">
                <CustomTable
                  header={trainingDetailsConfig.HeaderConfig}
                  data={trainingDetailsList || []}
                />
              </TabPanel>
              <TabPanel value="1">
                <CustomTable
                  header={trainingDetailsConfig.HeaderConfig.filter(
                    (data) => !["trainingStatus"].includes(data.id)
                  )}
                  data={trainingRequestList || []}
                />
              </TabPanel>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
};

export default TrainingApprovalStatus;
